import { useAppDispatch, useAppSelector } from "../store";
import {
  getNotifications,
  notifications
} from "../store/slices/user";

const useAppointments = () => {
  const dispatch = useAppDispatch();
  const notificationsData = useAppSelector(notifications);
  const fetchNotifications = () => dispatch(getNotifications());

  return {
    notificationsData,
    fetchNotifications
  };
};

export default useAppointments;
